import React, { Component } from 'react';
import Loading from '../../../Components/Loading.js'
import update from 'immutability-helper';
import { getFileExtensions, getFileMimeTypes, getFileMaxSizeMb } from '../../../Api/Namezzz'
import { getTranslation } from '../../../Utilities/GetTranslation.js'
import { postMessageAttachment } from '../../../Api/ExtranetActions.js';

declare var $;
declare var globalSns;

class ControlExtranetUploads extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            fileuploads : [
                {
                    file: this.el,
                    seqtemp: "0",
                    fileName: ""
                }
            ]
        }
        this.addFileUpload = this.addFileUpload.bind(this); 
    }

    componentWillMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.historyId == null && this.props.historyId != null) {
            this.saveDataAll();
        }
        if (prevProps.documentLabels !== this.props.documentLabels) {
            let file = this.el;
            if (file != null) {
                file.value = null;
            }
            
            this.setState({
                fileuploads: [
                    {
                        file: file,
                        seqtemp: "0",
                        fileName: ""
                    }
                ]
            });
        }
    }

    loadData() {
        getFileExtensions((data) => {
            this.setState({
                fileExtensions: data
            });
        });
        getFileMimeTypes((data) => {
            this.setState({
                fileMimeTypes: data
            });
        });
        getFileMaxSizeMb((data) => {
            this.setState({
                maxSizeMb: data
            });
        });
    }

    async saveDataAll() {
        let fileuploads = this.state.fileuploads;

        for (var i = 0; i < fileuploads.length - 1; i++) {
            if (fileuploads[i].removed) {
                continue;
            }
            await this.saveData(fileuploads[i]);
        }

        this.props.onSaved();
    }

    saveData(fileupload) {
        return new Promise(ok => {
            postMessageAttachment(fileupload.file, fileupload.seqtemp, this.props.historyId, globalSns.languageId, (newData) => {
                ok(newData != null)
            });
        });
    }

    addFileUpload() {
        var file = this.el;
        var errDoclabel = this.errDoclabel;
        var errType = this.errType;
        var errSize = this.errSize;

        if (file == null || file.files.length !== 1) {
            return;
        }

        errDoclabel.style.display = "none";
        errType.style.display = "none";
        errSize.style.display = "none";

        var fileSeqTemp = this.doclabel.value;
        var fileName = file.files[0].name;
        var fileExtension = fileName.split(".").pop().toLowerCase();
        var fileMimeType = file.files[0].type.toLowerCase();
        var fileSizeMb = file.files[0].size / 1024 / 1024;
        var errorOccured = false;

        if (fileSeqTemp === "0") {
            errDoclabel.style.display = "block";
            file.value = null;
            errorOccured = true;
        }

        if (this.state.fileExtensions.indexOf(fileExtension) < 0 ||
            this.state.fileMimeTypes.indexOf(fileMimeType) < 0)
        {
            errType.style.display = "block";
            file.value = null;
            errorOccured = true;
        }

        if (this.state.maxSizeMb <= fileSizeMb) {
            errSize.style.display = "block";
            file.value = null;
            errorOccured = true;
        }

        if (errorOccured) {
            return;
        }

        var fileupload = {
            file: file,
            seqtemp: fileSeqTemp,
            fileName: fileName,
            removed: false
        }

        this.setState({
            fileuploads: update(this.state.fileuploads, {$unshift: [fileupload]})
        });
        
        this.doclabel.value = "0";
    }

    removeFileUpload(fileupload) {
        var index = this.state.fileuploads.indexOf(fileupload);

        this.setState({
            fileuploads: update(this.state.fileuploads, {[index]: {removed: {$set: true}}})
        })
    }

    render() {

        if (this.state.fileExtensions == null || this.state.fileMimeTypes == null || this.state.maxSizeMb == null ||
            this.props.historyId != null) {
            return (
                <Loading/>
            );
        }

        if (this.props.documentLabels == null) {
            return "";
        }

        return (
            <div>
                <div className="tr">
                    <div className="FieldLabel td">
                        <label htmlFor="upload1">{getTranslation("sns.webparts.uploads.attachments")}
                        </label>
                    </div>
                    <div className="EditingFormValueCell td">
                        <div className="namezzzAttachments">
                            <div>
                                {
                                    this.state.fileuploads.map((fileupload, index) =>
                                        (fileupload.removed) ? "" :
                                            <div className="js-namezzzattachments-upload" key={index}>
                                                {
                                                    (this.props.documentLabels) ?
                                                        <div>
                                                            <select className="DropDownField form-control" ref={el => this.doclabel = el}>
                                                                <option value="0">{getTranslation("sns.formcontrols.namezzzattachments.choosedoclabel")}</option>
                                                                {
                                                                    this.props.documentLabels.map((doclabel) =>
                                                                        <option key={doclabel.templateId} value={doclabel.templateId}>{doclabel.value}</option>
                                                                    )
                                                                }
                                                            </select>
                                                            &nbsp;
                                                        </div> :
                                                        ""
                                                }
                                                <div className="uploader-file" onClick={() => this.removeFileUpload(fileupload)}>
                                                    {
                                                        (index !== this.state.fileuploads.length - 1) ?
                                                            <span>{fileupload.fileName}</span> : ""
                                                        
                                                    }
                                                </div>
                                                <div className="uploader-upload">
                                                    <input id={"uploadid_" + index} ref={el => this.el = el} type="file" onChange={this.addFileUpload} />
                                                </div>
                                                <div className="js-namezzzattachments-error js-namezzzattachments-label-error" ref={el => this.errDoclabel = el} style={{display: "none"}}>
                                                    <span className="EditingFormErrorLabel">{getTranslation("sns.formcontrols.namezzzattachments.filelabelerror")}</span>
                                                </div>
                                                <div className="js-namezzzattachments-error js-namezzzattachments-type-error" ref={el => this.errType = el} style={{display: "none"}}>
                                                    <span className="EditingFormErrorLabel">{getTranslation("sns.formcontrols.namezzzattachments.filetypeerror")}</span>
                                                </div>
                                                <div className="js-namezzzattachments-error js-namezzzattachments-size-error" ref={el => this.errSize = el} style={{display: "none"}}>
                                                    <span className="EditingFormErrorLabel">{getTranslation("sns.formcontrols.namezzzattachments.filesizeerror")}</span>
                                                </div>                                            
                                            </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ControlExtranetUploads;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ControlExtranetUploads.js